import {
  Dispatch,
  RefObject,
  SetStateAction,
  useEffect,
  useState,
} from 'react';

const usePanel: (
  ref: RefObject<HTMLElement>
) => [boolean, Dispatch<SetStateAction<boolean>>] = (ref) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e: Event) => {
      if (ref?.current?.contains(e.target as Node)) {
        return;
      }
      setOpen(false);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [ref]);
  return [open, setOpen];
};

export default usePanel;
